module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../node_modules/axios/index.js
// module id = 147
// module chunks = 0